import _ReturnIcon from "@sk/icons/lib/ReturnIcon";
import _DeleteFilledIcon from "@sk/icons/lib/DeleteFilledIcon";
import _FailIcon from "@sk/icons/lib/FailIcon";
import _InformIcon from "@sk/icons/lib/InformIcon";
import _ModifyIcon from "@sk/icons/lib/ModifyIcon";
import _RepeatFilledIcon from "@sk/icons/lib/RepeatFilledIcon";
import React from 'react';
import AntdModal from 'antd/lib/modal';
var ConfirmModal = props => {
  switch (props.type) {
    case 'recalculate':
      return AntdModal.confirm({
        className: 'confirm-modal',
        title: props.title,
        content: props.content,
        icon: /*#__PURE__*/React.createElement(_RepeatFilledIcon, {
          className: "confirm-icon"
        }),
        okText: props.okText || '确认',
        cancelText: props.cancelText || '取消',
        onOk: props.onOk
      });
    case 'edit':
      return AntdModal.confirm({
        className: 'confirm-modal',
        title: props.title,
        content: props.content,
        icon: /*#__PURE__*/React.createElement(_ModifyIcon, {
          className: "confirm-icon"
        }),
        okText: props.okText || '确认',
        cancelText: props.cancelText || '取消',
        onOk: props.onOk
      });
    case 'warning':
      return AntdModal.confirm({
        className: 'confirm-modal',
        title: props.title,
        content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
          className: "content"
        }, props.content), /*#__PURE__*/React.createElement("div", {
          className: "desc"
        }, props.description)),
        icon: /*#__PURE__*/React.createElement(_InformIcon, {
          className: "confirm-icon"
        }),
        okText: props.okText || '确认',
        cancelText: props.cancelText || '取消',
        onOk: props.onOk
      });
    case 'error':
      return AntdModal.error({
        className: 'confirm-modal',
        title: props.title,
        content: props.content,
        icon: /*#__PURE__*/React.createElement(_FailIcon, {
          className: "confirm-icon"
        }),
        okText: '确认',
        onOk: props.onOk
      });
    case 'delete':
      return AntdModal.confirm({
        className: 'confirm-modal',
        title: props.title,
        content: props.content,
        icon: /*#__PURE__*/React.createElement(_DeleteFilledIcon, {
          className: "confirm-icon"
        }),
        okText: props.okText || '确认并删除',
        cancelText: props.cancelText || '取消',
        onOk: props.onOk
      });
    case 'recover':
      return AntdModal.confirm({
        className: 'confirm-modal',
        title: props.title,
        content: props.content,
        icon: /*#__PURE__*/React.createElement(_ReturnIcon, {
          className: "confirm-icon"
        }),
        okText: props.okText || '恢复',
        cancelText: props.cancelText || '取消',
        onOk: props.onOk
      });
    default:
      return null;
  }
};
export default ConfirmModal;